import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError, Observable, timer } from 'rxjs';
import { SecurityService } from 'src/app/quote/services/http/security.service';
import { LocalStorageService } from '../services/local-storage.service';
import { LoginMessageService } from 'src/app/auth/pages/login/login.message.service';
import * as commonActions from 'src/app/common/common.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { isCountryBR } from '../util/util';
import * as ptErrors from 'src/assets/api/langs/pt.json';
import * as esErrors from 'src/assets/api/langs/es.json';

@Injectable({ providedIn: 'root' })
export class SecurityInterceptor implements HttpInterceptor {
  private securityService: SecurityService;

  // Definir la blacklist de endpoints
  private blacklist: string[] = [
    'api-artico/actuator/health/ping',
    '/api/v1/artico-mp/compliance',
    'api-artico/api/v1/artico-mp/policy-document/download',
    '/access-control/logout',
  ];

  constructor(
    private localStorageService: LocalStorageService,
    private injector: Injector,
    private loginMessage: LoginMessageService,
    private store: Store<AppState>
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.localStorageService.get('sessionToken');
    let request = req;

    if (token) request = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (!this.securityService) this.securityService = this.injector.get(SecurityService);

        // Manejo de errores específicos (401, 403, 419)
        if (err.status === 401 || err.status === 403 || err.status === 419) {
          this.securityService.logout();
          if (err.status === 401) this.loginMessage.setLoginMessage('MP-LOGIN-SERVICE-ERROR');
          if (err.status === 403 || err.status === 419)
            this.loginMessage.setLoginMessage('MP-LOGIN-SESSION-ERROR');
        }

        // Verificar si la URL está en la blacklist
        const isBlacklisted = this.blacklist.some((endpoint) => req.url.includes(endpoint));
        if (isBlacklisted) {
          throw err; // Re-lanzar el error sin disparar el toast
        }

        // Obtener código de error del backend
        const errorCode = err.error?.errorCode || err.error?.code;
        const params = err.error?.params || [];
        let errorMessage = '';

        // Seleccionar idioma
        const errorsDict = isCountryBR() ? ptErrors : esErrors;

        if (errorCode && (errorsDict as any)[errorCode]) {
          errorMessage = (errorsDict as any)[errorCode];
          // Interpolación de parámetros {0}, {1}, ...
          errorMessage = errorMessage.replace(/\{(\d+)\}/g, (match, index) => {
            return typeof params[index] !== 'undefined' ? params[index] : match;
          });
        } else if (err.error?.message) {
          errorMessage = this.truncateMessage(err.error.message, 200);
        } else {
          errorMessage = this.truncateMessage(errorCode || (isCountryBR() ? 'Ocorreu um erro inesperado.' : 'Ocurrió un error inesperado.'), 200);
        }

        this.store.dispatch(
          commonActions.viewToast({
            message: errorMessage,
          })
        );

        // Limpiar el estado del toast después de un retraso
        timer(5000).subscribe(() => {
          this.store.dispatch(commonActions.clearToast());
        });

        throw new Error(errorMessage);
      })
    );
  }

  // Función para truncar cadenas largas
  private truncateMessage(message: string, maxLength: number): string {
    if (message.length > maxLength) {
      return message.substring(0, maxLength) + '...';
    }
    return message;
  }
}
